
<div class="modal-body">
    <p style="font-size: 1.5rem;">
        Your session is about to time out, do you want to continue your session?
        {{displayTime}} time left
    </p>
</div>
<div class="modal-footer">
     <p-button label="Logout" size="small" (click)="logout()"></p-button>
    <p-button label="Stay logged In" size="small" (click)="resumeSession()"> </p-button>
</div>
